import axios from 'axios';
import {maintenanceStatusApi, configApi} from '../../utils/constants/EndPoint';

export function getMaintenanceStatusService(appConfig) {
  const url = `${appConfig.exrServiceApi + maintenanceStatusApi}?countryCode=${appConfig.countryCode}`;
  return axios.get(url);
}

export function getConfigService(appConfig) {
  const url = `${appConfig.exrServiceApi + configApi}`;
  return axios.get(url);
}
